const partTypeFilterHelpers = require('public/templates/modules/part_type_filter/utils');

/* global rp$, window */
'use strict';
const {
	prepareFacets,
} = require('public/js/components/search-facets');

const {
	prepareSearchResults,
} = require('public/js/search-helper');

const utils = require('public/js/helpers/utils');

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/

	(function OemAssembliesModule() {
		$onReady({
			rp$, window,
			label: 'oem_assemblies',
			fn: function () {
				// Assembly thumbnails: compute minimal visual height among all diagrams (content + container paddings)
				(function() {
					var allHeights = [];
					rp$('.part-group-container .pp-image-container').each(function() {
						var cont = this;
						var img = cont.querySelector('.pp-image');
						if (!img) { return; }
						var inlineH = 0;
						if (img.style && img.style.height) {
							var m = img.style.height.match(/(\d+(?:\.\d+)?)/);
							inlineH = m ? parseFloat(m[1]) : 0;
						}
						var computedH = 0;
						try { computedH = parseFloat(window.getComputedStyle(img).height) || 0; } catch(e) {}
						var contentH = inlineH || computedH || img.clientHeight || img.offsetHeight || 0;
						var padTop = 0, padBottom = 0;
						try {
							var csC = window.getComputedStyle(cont);
							padTop = parseFloat(csC.paddingTop) || 0;
							padBottom = parseFloat(csC.paddingBottom) || 0;
						} catch(e) {}
						var visual = contentH + padTop + padBottom;
						if (visual > 0) { allHeights.push(visual); }
					});

					var cssOffsetRawApply = (function(){
						try { return window.getComputedStyle(document.documentElement).getPropertyValue('--gmv-thumb-offset'); } catch(e) { return '0'; }
					})();
					var offsetAdjustApply = parseFloat(cssOffsetRawApply) || 0;

					var minVisual = allHeights.length ? Math.min.apply(null, allHeights) : rp$('#parts_diagram_1').outerHeight();
					var targetHeight = (minVisual + offsetAdjustApply);

					var thumbsOH = rp$('.assembly-thumbnails').outerHeight();
					if (targetHeight < thumbsOH) {
						rp$('.assembly-thumbnails').css('max-height', targetHeight + 'px').css('overflow-y','scroll');
					}
				})();
				

				function AddAllEvents() {
					// Assembly thumbnail click
					rp$('.assembly-thumbnail').on('click',function(e) {
						e.preventDefault();
						var target = this.hash;
						var firstAssembly = rp$('#parts_diagram_0').outerHeight()*.5;
						var $target = rp$(target).offset().top - firstAssembly;
						rp$('html, body').stop().animate({'scrollTop': $target}, 300, 'swing');
					});

					// Hotspot Target click
					rp$('.hotspot-scroll-link, .hotspot-see-more-link').on('click',function(e) {
						e.preventDefault();
						rp$('.product-diagram').modal('hide');
						var closestAssembly = rp$(this).closest('.pp-image-container').outerHeight();
						var target = this.hash;
						var $target = (rp$(target).offset().top - (closestAssembly*.5));
						rp$('html, body').stop().animate({'scrollTop': $target}, 900, 'swing');
					});

					// Hotspot Row Highlight
					rp$('.hotspot, .part-row').on({

						mouseenter: function () {
							var $this = rp$(this);
							var part_group = $this.attr('data-pgr-idx');
							var reference_code = $this.attr('data-reference-code');
							if(part_group && reference_code) {
								if($this.hasClass('hotspot')) {
									rp$('.part-row-'+part_group+'-'+ reference_code).addClass('part-row-highlight');
								}
								rp$(this).addClass('hotspot-highlight-active');
								rp$('.hotspot-'+part_group+'-'+ reference_code).addClass('hotspot-highlight');
							}
							if($this.hasClass('hotspot')) {
								$this.find('.hotspot-menu').show();
							}
						},
						mouseleave: function () {
							var $this = rp$(this);
							var part_group = $this.attr('data-pgr-idx');
							var reference_code = $this.attr('data-reference-code');
							if(part_group && reference_code) {
								if($this.hasClass('hotspot')) {
									rp$('.part-row-'+part_group+'-'+ reference_code).removeClass('part-row-highlight');
								}
								rp$('.hotspot-'+part_group+'-'+ reference_code).removeClass('hotspot-highlight hotspot-highlight-active');
							}
							if($this.hasClass('hotspot')) {
								$this.find('.hotspot-menu').hide();
							}
						}
					});
					if(window.tracking.google.use_gtag_admind_analytics){
						rp$('.product-title').on('click', 'a', function HookProductTitleClick(evt) {
							const product = utils.productTitleEvent( rp$(this).parent().parent() , rp$('.subcategory.active-cat')[0], 'Assemblies');
							window.rp_app.track.track_ec_general('select_item', {
								currency:window.rp_app.cart._currency_code,
								items:utils.convertNamesOfItemsForGA([product])
							});
						});
					}

					rp$('#relatedAssemblies .view-related-assemblies').on('click', function(e) {
						e.preventDefault();
						var $anchor = rp$(this),
							$assemblies = rp$('#relatedAssemblies .related-assemblies-row');

						$anchor.toggleClass('active');
						$assemblies.slideToggle(function () {
							try {
								window.rp_app.frameHandler.forceCheck();
							} catch (e) {
								// Do nothing.. we're just doing an iframe resize... if we're inside one
							}
						});
					});

					// If there was a direct hit on product page, highlight/scrollto that part on-page
					(function() {
						if(rp$('tr.page-part-num').length > 0) {
							window.setTimeout(function() {
								var top_y = rp$('tr.page-part-num').first().offset().top;
								var window_h = rp$(window).height();
								if(window_h < top_y) {
									rp$('body').scrollTop(top_y - (window_h / 3));
								}
							}, 1000);
						}

					})();
				}
				AddAllEvents();

				/* Handle Search Results Request
				.*-----------------------------------------*/
				function HandleSearchResultsRequest(evt) {
					partTypeFilterHelpers.showSpinner();
				}
				rp$(document).off('searchResults:request', HandleSearchResultsRequest);
				rp$(document).on('searchResults:request', HandleSearchResultsRequest);

				/* Handle Search Results Error
				.*-----------------------------------------*/
				function HandleSearchResultsError(evt) {
					rp$('.oem-assemblies-module').overlaySpinner.remove();
					rp_app.notify.add_notification(javascriptContent.search_error, 'error');
				}
				rp$(document).off('searchResults:error', HandleSearchResultsError);
				rp$(document).on('searchResults:error', HandleSearchResultsError);

				/* Handle Search Results Response
				.*-----------------------------------------*/
				function HandleSearchResultsResponse(evt, response) {
					var $listingModule = rp$('.oem-assemblies-module');
					$listingModule.overlaySpinner.remove();

					if(response.listings_html) {
						$listingModule.replaceWith(response.listings_html);
						if (typeof rp$.fn.add_to_cart === 'function') {
							rp$('.oem-assemblies-module').find('.add-to-cart.enabled').add_to_cart();
						}
						if (typeof rp$.fn.product_quantity === 'function') {
							rp$('.search-listing-module').product_quantity();
						}
						AddAllEvents();
					}

					if(response.mobile_facets || response.desktop_facets) {
						var $addMobile = rp$('.filters-overlay-content').find('.search-facets-module');
						var $addDesktop = rp$('.desktop-search-filters').find('.search-facets-module');
						$addDesktop.replaceWith(response.desktop_facets);
						$addMobile.replaceWith(response.mobile_facets);
						prepareSearchResults(response.use_cfc);
						prepareFacets();
					}

					rp$('.result-count').each(function CountEle_Iterator(/*idx*/) {
						handleNewCount(rp$(this), response.count);
					});
					rp$('.result-ymm-text').html(response.ymm_text);
				}
				rp$(document).off('searchResults:response', HandleSearchResultsResponse);
				rp$(document).on('searchResults:response', HandleSearchResultsResponse);
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
